import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { MatSnackBar } from '@angular/material';
import { Subject } from 'rxjs';

const apiURL = environment.apiURL;

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  private ordersSub = new Subject<any>();

  constructor(private http: HttpClient, private snackBar: MatSnackBar) { }

  setOrders(data) {
    this.ordersSub.next(data);
  }

  getOrdersUpdated() {
    return this.ordersSub.asObservable();
  }

  calculatePrice(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/price`, data);
  }

  calculatePriceAsAdmin(data) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/price/admin`, data);
  }

  createOrder(data: any) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders`, data);
  }

  createOrderAsAdmin(data: any) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/admin`, data);
  }

  getAllOrders(data: any) {
    return this.http.post<{ sucess: boolean, data: any }>(`${apiURL}/orders/query`, data);
  }

  getAllOrdersAdAdmin(data: FormData) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/query/admin/`, data);
  }

  addPaymentAsAdmin(data: any) {
    return this.http.post<{ sucess: boolean, data: any }>(`${apiURL}/orders/payment`, data);
  }

  cancelOrder(data: any) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/cancel`, data);
  }

  getAnOrder(data: any) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/get`, data);
  }

  updateOrderAsAdmin(data: any) {
    return this.http.put<{ success: boolean, data: any }>(`${apiURL}/orders/admin`, data);
  }

  pauseOrderAsAdmin(data: any) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/pause/admin`, data);
  }

  deleterderAsAdmin(data: any) {
    return this.http.post<{ success: boolean, data: any }>(`${apiURL}/orders/remove/admin`, data);
  }
}
